import { render, staticRenderFns } from "./ModalRestrictOrders.vue?vue&type=template&id=07041222&scoped=true&"
import script from "./ModalRestrictOrders.vue?vue&type=script&lang=js&"
export * from "./ModalRestrictOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalRestrictOrders.vue?vue&type=style&index=0&id=07041222&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07041222",
  null
  
)

export default component.exports